import React from "react";

export default function IntroStage({ onStart }) {
  return (
    <div className="text-center">
      <p className="mb-3 text-sm text-mist/80">
        Three balls. No lessons this time — just bumpers, targets, and one big{" "}
        <span className="text-gold">jackpot</span> if you can light all three.
      </p>
      <ul className="mb-6 space-y-1 text-left text-xs text-mist/60">
        <li>◀ ▶ or A / D to work the flippers — on touch, tap the left or right half of the table</li>
        <li>Space, or tap the table while the ball's waiting, to launch</li>
        <li>Bumpers and targets score points; light all 3 targets for a 1,000-point jackpot</li>
        <li>3 balls per game — your final score becomes XP and net worth, same as any level</li>
      </ul>
      <button onClick={onStart} className="btn-magenta">
        ▶ DROP THE BALL
      </button>
    </div>
  );
}
